import {
  CButton,
  CCol,
  CContainer,
  CModal,
  CModalBody,
  CModalFooter,
  CModalHeader,
  CModalTitle,
  CRow,
} from "@coreui/react";
import { useState } from "react";
import { Spinner } from "react-bootstrap";
import { SUCCESS } from "../../utils/constants/tags";
import { errorAlert } from "../utils/messages";
import WebhookEndpoint from "../../models/webhook-endpoint";
import { deleteWebhookEndpoint } from "../../api/webhook-endpoints";

interface WebhookEndpointDeleteModalProps {
  show: boolean;
  endpoint?: WebhookEndpoint;
  onCancel: () => void | Promise<void>;
  onSuccess: () => void | Promise<void>;
}

const WebhookEndpointDeleteModal: React.FC<WebhookEndpointDeleteModalProps> = ({
  show,
  endpoint,
  onCancel,
  onSuccess,
}) => {
  const [submitting, setSubmitting] = useState(false);

  const message = endpoint
    ? `¿Está seguro de que quiere eliminar el webhook "${endpoint.name}"? Esta acción eliminará también el historial de eventos asociado.`
    : "";

  const onDeleteClick = async () => {
    if (endpoint !== undefined && endpoint.id !== undefined) {
      setSubmitting(true);
      const status = await deleteWebhookEndpoint(endpoint.id);

      if (status.status !== SUCCESS) {
        const msg = status.detail ?? "Ha ocurrido un error!!";
        errorAlert(msg);
      } else {
        onSuccess();
      }

      setSubmitting(false);
    }
  };

  return (
    <CModal show={show} className="modal-danger" onClosed={onCancel} size="xl">
      <CModalHeader closeButton>
        <CModalTitle>Eliminar Webhook</CModalTitle>
      </CModalHeader>
      <CModalBody>
        <CContainer fluid>
          <CRow>
            <CCol sm="12">
              <h2>{message}</h2>
            </CCol>
          </CRow>
        </CContainer>
      </CModalBody>
      <CModalFooter>
        <CButton disabled={submitting} onClick={onDeleteClick} color="danger">
          {submitting ? (
            <Spinner
              animation="grow"
              style={{
                height: "17px",
                width: "17px",
                marginTop: "auto",
                marginBottom: "auto",
                marginRight: "10px",
              }}
            />
          ) : (
            <></>
          )}
          {submitting ? "Eliminando..." : "Eliminar"}
        </CButton>
      </CModalFooter>
    </CModal>
  );
};

export default WebhookEndpointDeleteModal;
